// extracted by mini-css-extract-plugin
export default {"greetingCounter":"styles_greetingCounter__P4idH","title":"styles_title__Yfei7","text":"styles_text__N13Cx","titleHeader":"styles_titleHeader__5SwFI"};